/**
 * Wspólne reguły walidacji pól standardowych klienta (LSD-526) dla mk1.
 * Limity muszą być zgodne z API (ClientStandardFieldsValidator w LS\Common)
 * oraz z odpowiednikiem mk2 (gui/member2/src/utils/standardFieldValidation.js).
 */

export const NAME_MIN_LENGTH = 2;
export const POSTCODE_PATTERN = /^[0-9]{2}-[0-9]{3}$/;

/**
 * Auto-format kodu pocztowego: tylko cyfry, myślnik wstawiany po 2 cyfrach.
 * @param {string} value
 * @returns {string}
 */
export function formatPostcode(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 5);
  return digits.length > 2 ? digits.slice(0, 2) + '-' + digits.slice(2) : digits;
}

/**
 * @param {string} value
 * @returns {boolean} true gdy pusty lub w formacie 00-000
 */
export function isValidPostcode(value) {
  const v = String(value || '').trim();
  return v.length === 0 || POSTCODE_PATTERN.test(v);
}

/**
 * @param {string} value
 * @returns {boolean} true gdy pusty lub ma co najmniej 2 znaki
 */
export function isValidNamePart(value) {
  const v = String(value || '').trim();
  return v.length === 0 || v.length >= NAME_MIN_LENGTH;
}
